import { FC, memo } from 'react';
import SiteMenu from '../SiteMenu/SiteMenu';
import Blocks from '../Blocks/Blocks';
import { UsersTable } from './UsersTable/UsersTable';
import { useUsers } from '../../hooks/components/useUsers/useUsers';
import { UsersTableFilter } from './UsersTable/UsersTableFilter/UsersTableFilter';
import { ButtonPopup } from '../../features/popup/ButtonPopup/ButtonPopup';
import AddUserPopupAdapter from '../../features/users/AddUserPopup/AddUserPopupAdapter';
import { useUsersStyle } from '../../hooks/components/useUsers/useUsersStyle';
import blockStyles from '../Blocks/style.module.css';
import { PlusOutlined } from '@ant-design/icons';

export const Users: FC = memo(() => {
  const propsUsers = useUsers();
  useUsersStyle([]);
  return (
    <>
      <Blocks
        topBlock={
          <div className={blockStyles.topBlockRow}>
            <SiteMenu
              title="Настройки: Пользователи"
              subtitle="Управление пользователями системы"
              svg={true}
              svgType="users"
            />
            <ButtonPopup
              isWide={true}
              title={'Добавить пользователя'}
              PopupComponent={AddUserPopupAdapter}
              extra={{
                icon: <PlusOutlined />,
                callRequest: propsUsers.callRequest,
              }}
            />
          </div>
        }
        middleBlock={
          <UsersTableFilter
            clinics={propsUsers.clinics}
            roles={propsUsers.roles}
            filterOption={propsUsers.filterOption}
            clinicValue={propsUsers.clinicValue}
            handleClinicsChange={propsUsers.handleClinicsChange}
            handleOpenClinics={propsUsers.handleOpenClinics}
            roleValue={propsUsers.roleValue}
            handleRoleChange={propsUsers.handleRoleChange}
            handleOpenRoles={propsUsers.handleOpenRoles}
            isLockoutValue={propsUsers.isLockoutValue}
            handleIsLockoutChange={propsUsers.handleIsLockoutChange}
            handleOpenIsLockout={propsUsers.handleOpenIsLockout}
            onSearch={propsUsers.handleSearch}
            disabled={propsUsers.isLoading}
          />
        }
        mainBlock={
          <UsersTable
            callRequest={propsUsers.callRequest}
            pageSize={propsUsers.pageSize}
            totalCount={propsUsers.total}
            total={propsUsers.total}
            allUsers={propsUsers.allUsers}
            divider={propsUsers.divider}
            COLUMNS={propsUsers.COLUMNS}
            onChange={propsUsers.handleChange}
            onTableChange={propsUsers.onTableChange}
            handlePageSizeChange={propsUsers.handlePageSizeChange}
            loading={propsUsers.isLoading}
            hasLoadError={propsUsers.hasLoadError}
          />
        }
      />
    </>
  );
});

Users.displayName = 'Users';
